export default __webpack_public_path__ + "static/media/iPhone-X3.24c5b368.png";